<template>

  <div class="text-center" style="position: sticky;background: #fff;height:30px;top:0;z-index:1">
    <a class="text-normal">
      <el-pagination class="pagination" layout="prev, pager, next" :total="result_data.count"
      :page-size="search_data.limit" @current-change="handleCurrentChange" :current-page="search_data.page"/>
    </a>
  </div>

	<!-- <div>


		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="search_data.page"
		 :page-sizes="[10, 20, 30, 40 ,50]" :page-size="search_data.limit" layout="total, sizes, prev, pager, next, jumper"
		 :total="result_data.count">
		</el-pagination>


	</div> -->
</template>
<script>
	var _this;
	export default {

		created() {

			_this = this;

		},
		// 接受父组件传的值
		props: {
			search_data: {},
			result_data: {}
		},
		// 监听父组件传过来的值
		watch: {

			search_data(newData, oldData) {

        _this.search_data = newData;



        console.log(_this.search_data.page);


			},

			result_data(newData, oldData) {

				_this.result_data = newData;

			}

		},
		data() {
			return {

			}
		},
		methods: {


			//下拉条（每页显示多少数据）变化
			// handleSizeChange(val) {

      //   console.log(val);

			// 	// _this.search_data.limit = val;

			// 	_this.$emit('selectPages_function', _this.search_data);

			// },

			//页码变化
			handleCurrentChange(val) {
        // console.log(val);

				_this.search_data.page = val;
				//初始化显示列表
				_this.$emit('selectPages_function', _this.search_data);


			},

		}
	}
</script>



// WEBPACK FOOTER //
// src/common/mine/selectPages.vue